import { forwardRef } from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';
import { Description } from './fieldset';

/**
 * Voir : https://s-yadav.github.io/react-number-format/docs/customization#iban-account-input-field-with-pattern
 */
export const PhoneInput = forwardRef<PatternFormatProps>((props, ref) => {
  return <PatternFormat {...props} format="## ## ## ## ##" mask="_" placeholder="Ex: 06 12 34 56 78" getInputRef={ref} />;
});

/**
 * Indication du format attendu, affichée sous les champs numéro de téléphone
 */
export const PhoneFormatHint = () => <Description>Format attendu : 0606060606</Description>;
